import { inject, Injectable } from '@angular/core';
import { AppConfig } from '../config/app.config';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { clearanceStepAPIconfig, PreferredReports } from '../enums/config.enum';
import { clearanceIndicationData, clearanceQuoteData, PolicyParametersData, quoteComparisonResponce, UserDetails } from '../models/RequestQuote';
import { BrokerQuoteService } from './brokerQuote.service';
import { AuthService } from '../auth/auth.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';



@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  private apiUrl = AppConfig.propertyUrl;
  private apiKey = AppConfig.apiKey;
  private Url = AppConfig.apiUrl;
  authservice = inject(AuthService)       
  private token = this.authservice.getToken()  
  private filterTimeouts: { [key: string]: any } = {};
  brokerQuoteService = inject(BrokerQuoteService);
  authService = inject(AuthService);
  httpClient = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  constructor() { } 
  
  startNewQuote(): Observable<any> {
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;
    const path=`/api/clearance/TempQuoteId?userid=${userId}`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, {});
  }  

  // clearanceStep(formData: any,policyType: string, insuredName: string,questions: any[],premium:number): Observable<any> {
  //   const tempQuoteId = sessionStorage.getItem('tempQuoteId');
  //   const createdUserId = sessionStorage.getItem('createdUserId')

  //   const addresses = formData.addresses.map((address: any,index: number) => ({
  //     addressId: index+1, 
  //     streetName: address.street,
  //     occupancy: address.occupancy.name,
  //     city: address.city,
  //     state: address.state,
  //     county: address.country,
  //     zipcode: Number(address.zipcode)
  //   }));

  //   const requestBody = {
  //     "quoteId": 0,
  //     policyType: policyType,
  //     insuredName: insuredName,
  //     createdUserId: createdUserId,
  //     premium: premium,
  //     addresses: addresses,
  //     questions: questions
  //   }    
  //   const url = `${this.Url}/Proxy?path=${encodedPath}/api/Clearance?tempid=${tempQuoteId}`;
  //   return this.httpClient.post(url, requestBody);
  // }

  clearanceStep(formData: any, preferredReports : any,preferredReportResponse:any, policyType: string, insuredName: string,questions: any[],premium:number, isPRSubmit: boolean = true, indicationStep: number | null = null): Observable<any> {
    const tempQuoteId = sessionStorage.getItem('tempQuoteId');
    const createdUserId = sessionStorage.getItem('createdUserId');
    const branchId = sessionStorage.getItem('branchId');
    const indicationId = sessionStorage.getItem("indicationId");
    const indicationNo = sessionStorage.getItem('indicationNo');

    const tempId = sessionStorage.getItem("indicationId") || sessionStorage.getItem('tempQuoteId')
  
    const currentDate = new Date().toISOString();
    const userDetails:UserDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;

    const buildings = [{
            buildingId: clearanceStepAPIconfig.DefaultValue,
            indicationId: indicationId ||clearanceStepAPIconfig.DefaultValue,
            buildingName: "",
            indicationAddressId: clearanceStepAPIconfig.DefaultValue,
            otherStructureFactorId: clearanceStepAPIconfig.DefaultValue,
            isDeleted: clearanceStepAPIconfig.DefaultValue,
            createdUserId: userId,
            createdDate: currentDate,
            buildingCoverages: {
              coverageId: clearanceStepAPIconfig.DefaultValue,
              indicationId: clearanceStepAPIconfig.DefaultValue,
              buildingId: clearanceStepAPIconfig.DefaultValue,
              coverageA: clearanceStepAPIconfig.DefaultValue,
              coverageC: clearanceStepAPIconfig.DefaultValue
            }
    }]

    const addresses = formData.addresses.map((address: any,index: number) => {
      const addressId = Number(address?.addressid) || clearanceStepAPIconfig.DefaultValue;
      const addressTypeId = address?.addressTypeId ?? index + 1;

      return {
            indicationAddressId: addressId,
            addressTypeId: addressTypeId,
            indicationId: indicationId||clearanceStepAPIconfig.DefaultValue,
            occupanyClassId: address.occupancy,
            unitNum: address.unitNum,
            streetNum: address.streetNum,
            streetName: address.street,
            cityId: address.city,
            countyId: address.country,
            stateId: address.state,
            zipCode: address.zipcode,
            isDeleted: clearanceStepAPIconfig.DefaultValue,
            createdUserId: userId,
            createdDate: currentDate,
            updatedUserId: userId,
            updatedDate: currentDate,
            indicationBuildings:buildings,
            addressCoverages: {
              coverageId: clearanceStepAPIconfig.DefaultValue,
              indicationId: clearanceStepAPIconfig.DefaultValue,
              indicationAddressId:clearanceStepAPIconfig.DefaultValue,
              coverageB: clearanceStepAPIconfig.DefaultValue,
              coverageD: clearanceStepAPIconfig.DefaultValue,
              totalCoverage: clearanceStepAPIconfig.DefaultValue
        }
    }});

    const requestBody = {
      indication: {
        indicationId: indicationId || clearanceStepAPIconfig.DefaultValue,
        branchId: branchId,
        indicationNo: indicationNo || "",
        indicationDate: currentDate,
        policyTypeId: policyType,
        indicationStep: indicationStep,
        nameInsured: insuredName,
        targetPremium: premium,
        calcPremium: null,
        policyStartDate: null,
        policyEndDate: null,
        versionNo: this.getVersionNo() ? Number(this.getVersionNo()) : 1,
        indicationStatus: Number(this.brokerQuoteService.getStatusId()),
        indicationReferralLock: clearanceStepAPIconfig.DefaultValue,
        indicationLock: clearanceStepAPIconfig.DefaultValue,
        indicationConverted: clearanceStepAPIconfig.DefaultValue,
        indicationOwner: userId,
        createdUserId: userId,
        createdDate: currentDate,
        updatedUserId: userId,
        updatedDate: currentDate,
        addresses: addresses,
        indicationDetails: {
          indicationDetailId: clearanceStepAPIconfig.DefaultValue,
          indicationId: indicationId || clearanceStepAPIconfig.DefaultValue,
          buildingCount: clearanceStepAPIconfig.DefaultValue,
          colFormType: clearanceStepAPIconfig.DefaultValue,
          aopDeductibleId: clearanceStepAPIconfig.DefaultValue,
          aopDeductibleAmount: clearanceStepAPIconfig.DefaultValue,
          windDeductibleFlag: clearanceStepAPIconfig.DefaultValue,
          windDeductibleId: clearanceStepAPIconfig.DefaultValue,
          windDeductibleFactor: clearanceStepAPIconfig.DefaultValue,
          propertyExtCoverageType: clearanceStepAPIconfig.DefaultValue,
          insuredContactName: insuredName,
          insuredEmail: userDetails.email,
          insuredMailingAddressId: clearanceStepAPIconfig.DefaultValue,
          producingAgentName: "",
          producingAgentEmail: "",
          producingAgentAddressId: clearanceStepAPIconfig.DefaultValue,
          producingAgentPhone: null,
          slAgentName: "",
          slAgentAddressId: clearanceStepAPIconfig.DefaultValue,
          slAgentLicenseNumber: String(clearanceStepAPIconfig.DefaultValue),
          slConfirmTaxFilings: clearanceStepAPIconfig.DefaultValue,
          ragId: clearanceStepAPIconfig.DefaultValue
        }
      },
      questions: questions,
      preferredReports : preferredReports,
      preferredReportResponse : preferredReportResponse
    }
    //const tempIdParams = tempQuoteId === null || "null" ? 0 : tempQuoteId;
    const path=`/api/Clearance/SaveIndicationClearance?tempid=${tempId}&isPRSubmit=${isPRSubmit}`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, requestBody);
  }

  clearanceQuoteStep(formData: any,preferredReports: any,preferredReportResponse:any,policyType: string, insuredName: string,questions: any[],premium:number, isPRSubmit: boolean = true, quoteStep: number | null = null): Observable<any> {
    //const tempQuoteId = sessionStorage.getItem('tempQuoteId');
    const quoteId = sessionStorage.getItem('quoteId')
    //const createdUserId = sessionStorage.getItem('createdUserId');
    const branchId = sessionStorage.getItem('branchId');
    const indicationId = sessionStorage.getItem("indicationId");
    //const indicationNo = sessionStorage.getItem('indicationNo');
    const quoteNo = sessionStorage.getItem('quoteNo');
    const quoteReferralLock = sessionStorage.getItem("quoteReferralLock");

    //const tempId = sessionStorage.getItem("indicationId") || sessionStorage.getItem('tempQuoteId')
  
    const currentDate = new Date().toISOString();
    const userDetails:UserDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;

     const addresses = formData.addresses.map((address: any,index: number) => {
      const addressId = Number(address?.addressid) || clearanceStepAPIconfig.DefaultValue;
      const addressType = address?.addressTypeId ?? index + 1;

      return {
            quoteAddressId: addressId,
            addressTypeId: addressType,
            quoteId: quoteId||clearanceStepAPIconfig.DefaultValue,
            occupanyClassId: address.occupancy,
            unitNum: address.unitNum,
            streetNum: address.streetNum,
            streetName: address.street,
            cityId: address.city,
            countyId: address.country,
            stateId: address.state,
            zipCode: address.zipcode,
            isDeleted: clearanceStepAPIconfig.DefaultValue,
            createdUserId: userId,
            createdDate: currentDate,          
            quoteBuildings:[],
            addressCoverages: {
              coverageId: clearanceStepAPIconfig.DefaultValue,
              quoteId: clearanceStepAPIconfig.DefaultValue,
              quoteAddressId:clearanceStepAPIconfig.DefaultValue,
              coverageB: clearanceStepAPIconfig.DefaultValue,
              coverageD: clearanceStepAPIconfig.DefaultValue,
              totalCoverage: clearanceStepAPIconfig.DefaultValue
        }
    }});

    const requestBody = {
      quote: {
        quoteId: quoteId || clearanceStepAPIconfig.DefaultValue,
        branchId: branchId,
        quoteNo: quoteNo || "",
        quoteDate: currentDate,
        policyTypeId: policyType,
        nameInsured: insuredName,
        targetPremium: premium,
        calcPremium: null,
        policyStartDate: null,
        policyEndDate: null,
        versionNo: this.getVersionNo() ? Number(this.getVersionNo()) : 1,
        quoteReferred: null,
        quoteReferralLock: quoteReferralLock,
        // quoteStatus: Number(this.brokerQuoteService.getStatusId()),
        quoteStep: quoteStep,
        quoteUserLock: null,
        quoteOwner: null,
        quoteVersionBound: null,
        quoteConverted: null,
        createdUserId: userId,
        createdDate: currentDate,
        updatedUserId: userId,
        updatedDate: currentDate,
        indicationId: indicationId,    
        addresses: addresses,    
      },
      questions: questions,       
      preferredReports : preferredReports,
      preferredReportResponse : preferredReportResponse  
    }
    const path=`/api/Clearance/SaveQuoteClearance?indicationId=${quoteId}&isPRSubmit=${isPRSubmit}`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, requestBody);
  }

  clearanceCheck(formData: any,policyType: string, insuredName: string,questions: any[],premium:number): Observable<any> {
    const tempQuoteId = sessionStorage.getItem('tempQuoteId');
    const createdUserId = sessionStorage.getItem('createdUserId');
    const branchId = sessionStorage.getItem('branchId');
    const indicationId = sessionStorage.getItem("indicationId");
    const indicationNo = sessionStorage.getItem('indicationNo');

    const tempId = sessionStorage.getItem("indicationId") || sessionStorage.getItem('tempQuoteId')
  
    const currentDate = new Date().toISOString();
    const userDetails:UserDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;

    const buildings = [{
            buildingId: clearanceStepAPIconfig.DefaultValue,
            indicationId: indicationId ||clearanceStepAPIconfig.DefaultValue,
            buildingName: "",
            indicationAddressId: clearanceStepAPIconfig.DefaultValue,
            otherStructureFactorId: clearanceStepAPIconfig.DefaultValue,
            isDeleted: clearanceStepAPIconfig.DefaultValue,
            createdUserId: userId,
            createdDate: currentDate,
            buildingCoverages: {
              coverageId: clearanceStepAPIconfig.DefaultValue,
              indicationId: clearanceStepAPIconfig.DefaultValue,
              buildingId: clearanceStepAPIconfig.DefaultValue,
              coverageA: clearanceStepAPIconfig.DefaultValue,
              coverageC: clearanceStepAPIconfig.DefaultValue
            }
    }]

    const addresses = formData.addresses.map((address: any,index: number) => {
      const addressId = Number(address?.addressid) || clearanceStepAPIconfig.DefaultValue;
      const addressType = address?.addressTypeId ?? index + 1;

      return {
            indicationAddressId: addressId,
            addressTypeId: addressType,
            indicationId: indicationId||clearanceStepAPIconfig.DefaultValue,
            occupanyClassId: address.occupancy,
            unitNum: address.unitNum,
            streetNum: address.streetNum,
            streetName: address.street,
            cityId: address.city,
            countyId: address.country,
            stateId: address.state,
            zipCode: address.zipcode,
            isDeleted: clearanceStepAPIconfig.DefaultValue,
            createdUserId: userId,
            createdDate: currentDate,
            updatedUserId: userId,
            updatedDate: currentDate,
            indicationBuildings:buildings,
            addressCoverages: {
              coverageId: clearanceStepAPIconfig.DefaultValue,
              indicationId: clearanceStepAPIconfig.DefaultValue,
              indicationAddressId:clearanceStepAPIconfig.DefaultValue,
              coverageB: clearanceStepAPIconfig.DefaultValue,
              coverageD: clearanceStepAPIconfig.DefaultValue,
              totalCoverage: clearanceStepAPIconfig.DefaultValue
        }
    }});

    const requestBody = {
      indication: {
        indicationId: indicationId || clearanceStepAPIconfig.DefaultValue,
        branchId: branchId,
        indicationNo: indicationNo || "",
        indicationDate: currentDate,
        policyTypeId: policyType,
        nameInsured: insuredName,
        targetPremium: premium,
        calcPremium: null,
        policyStartDate: null,
        policyEndDate: null,
        versionNo: this.getVersionNo() ? Number(this.getVersionNo()) : 1,
        indicationStatus: Number(this.brokerQuoteService.getStatusId()),
        indicationReferralLock: clearanceStepAPIconfig.DefaultValue,
        indicationLock: clearanceStepAPIconfig.DefaultValue,
        indicationConverted: clearanceStepAPIconfig.DefaultValue,
        indicationOwner: userId,
        createdUserId: userId,
        createdDate: currentDate,
        updatedUserId: userId,
        updatedDate: currentDate,
        addresses: addresses,
        indicationDetails: {
          indicationDetailId: clearanceStepAPIconfig.DefaultValue,
          indicationId: indicationId || clearanceStepAPIconfig.DefaultValue,
          buildingCount: clearanceStepAPIconfig.DefaultValue,
          colFormType: clearanceStepAPIconfig.DefaultValue,
          aopDeductibleId: clearanceStepAPIconfig.DefaultValue,
          aopDeductibleAmount: clearanceStepAPIconfig.DefaultValue,
          windDeductibleFlag: clearanceStepAPIconfig.DefaultValue,
          windDeductibleId: clearanceStepAPIconfig.DefaultValue,
          windDeductibleFactor: clearanceStepAPIconfig.DefaultValue,
          propertyExtCoverageType: clearanceStepAPIconfig.DefaultValue,
          insuredContactName: insuredName,
          insuredEmail: userDetails.email,
          insuredMailingAddressId: clearanceStepAPIconfig.DefaultValue,
          producingAgentName: "",
          producingAgentEmail: "",
          producingAgentAddressId: clearanceStepAPIconfig.DefaultValue,
          producingAgentPhone: null,
          slAgentName: "",
          slAgentAddressId: clearanceStepAPIconfig.DefaultValue,
          slAgentLicenseNumber: String(clearanceStepAPIconfig.DefaultValue),
          slConfirmTaxFilings: clearanceStepAPIconfig.DefaultValue,
          ragId: clearanceStepAPIconfig.DefaultValue
        }
      },
      questions: questions
    }
    //const tempIdParams = tempQuoteId === null || "null" ? 0 : tempQuoteId;
   
    const path=`/api/Clearance/CheckInsuredNameAndAddress`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, requestBody);
  }

   clearanceCheckQuote(formData: any,preferredReports: any,preferredReportResponse:any,policyType: string, insuredName: string,questions: any[],premium:number, isPRSubmit: boolean = true): Observable<any> {
    //const tempQuoteId = sessionStorage.getItem('tempQuoteId');
    const quoteId = sessionStorage.getItem('quoteId')
    //const createdUserId = sessionStorage.getItem('createdUserId');
    const branchId = sessionStorage.getItem('branchId');
    const indicationId = sessionStorage.getItem("indicationId");
    //const indicationNo = sessionStorage.getItem('indicationNo');
    const quoteNo = sessionStorage.getItem('quoteNo');
    const quoteReferralLock = sessionStorage.getItem("quoteReferralLock");

    //const tempId = sessionStorage.getItem("indicationId") || sessionStorage.getItem('tempQuoteId')
  
    const currentDate = new Date().toISOString();
    const userDetails:UserDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;

     const addresses = formData.addresses.map((address: any,index: number) => {
      const addressId = Number(address?.addressid) || clearanceStepAPIconfig.DefaultValue;
      const addressType = address?.addressTypeId ?? index + 1;

      return {
            quoteAddressId: addressId,
            addressTypeId: addressType,
            quoteId: quoteId||clearanceStepAPIconfig.DefaultValue,
            occupanyClassId: address.occupancy,
            unitNum: address.unitNum,
            streetNum: address.streetNum,
            streetName: address.street,
            cityId: address.city,
            countyId: address.country,
            stateId: address.state,
            zipCode: address.zipcode,
            isDeleted: clearanceStepAPIconfig.DefaultValue,
            createdUserId: userId,
            createdDate: currentDate,          
            quoteBuildings:[],
            addressCoverages: {
              coverageId: clearanceStepAPIconfig.DefaultValue,
              quoteId: clearanceStepAPIconfig.DefaultValue,
              quoteAddressId:clearanceStepAPIconfig.DefaultValue,
              coverageB: clearanceStepAPIconfig.DefaultValue,
              coverageD: clearanceStepAPIconfig.DefaultValue,
              totalCoverage: clearanceStepAPIconfig.DefaultValue
        }
    }});

    const requestBody = {
      quote: {
        quoteId: quoteId || clearanceStepAPIconfig.DefaultValue,
        branchId: branchId,
        quoteNo: quoteNo || "",
        quoteDate: currentDate,
        policyTypeId: policyType,
        nameInsured: insuredName,
        targetPremium: premium,
        calcPremium: null,
        policyStartDate: null,
        policyEndDate: null,
        versionNo: this.getVersionNo() ? Number(this.getVersionNo()) : 1,
        quoteReferred: null,
        quoteReferralLock: quoteReferralLock,
        quoteStep: null,
        quoteUserLock: null,
        quoteOwner: null,
        quoteVersionBound: null,
        quoteConverted: null,
        createdUserId: userId,
        createdDate: currentDate,
        updatedUserId: userId,
        updatedDate: currentDate,
        indicationId: indicationId,    
        addresses: addresses,    
      },
      questions: questions, 
    }
    const path=`/api/Clearance/CheckQuoteInsuredNameAndAddress`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, requestBody);
  }

  policySaveCleranceData(formData: any,policyType: string, insuredName: string,questions: any[],premium:number): Observable<any> {
    const quoteId = sessionStorage.getItem('quoteIdForPolicy');
    const branchId = sessionStorage.getItem('branchId');
    const policyNo = sessionStorage.getItem('policyNo');
    const policyDate = sessionStorage.getItem('policyDate');
    const policyStartDate = sessionStorage.getItem('policyStartDate');
    const policyEndDate = sessionStorage.getItem('policyEndDate');
    const policyStatus = sessionStorage.getItem('policyStatus');
    const currentDate = new Date().toISOString();
    const userDetails:UserDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;

    const addresses = formData.addresses.map((address: any,index: number) => {
      const addressId = Number(address?.addressid) || clearanceStepAPIconfig.DefaultValue;
      const addressType = address?.addressTypeId ?? index + 1;

      return {
      policyAddressId: addressId,
      addressTypeId: addressType,
      policyId: Number(this.authService.getUserDetailsFromStorage()?.policyId),
      occupanyClassId: address.occupancy,
      unitNum: address.unitNum,
      streetNum: address.streetNum,
      streetName: address.street,
      cityId: address.city,
      countyId: address.country,
      stateId: address.state,
      zipCode: address.zipcode,
      isDeleted: clearanceStepAPIconfig.DefaultValue,
      createdUserId: userId,
      createdDate: currentDate,  
      updatedUserId: userId,  
      updatedDate: currentDate,      
      policyBuildings:[],
      addressCoverages: {
        coverageId: clearanceStepAPIconfig.DefaultValue,
        policyId: clearanceStepAPIconfig.DefaultValue,
        policyAddressId:clearanceStepAPIconfig.DefaultValue,
        coverageB: clearanceStepAPIconfig.DefaultValue,
        coverageD: clearanceStepAPIconfig.DefaultValue,
        totalCoverage: clearanceStepAPIconfig.DefaultValue
      }
    }});

    const requestBody = {
      policy: {
        policyId: Number(this.authService.getUserDetailsFromStorage()?.policyId),
        quoteId: quoteId,
        branchId: branchId,
        policyNo: policyNo, //check
        policyDate: policyDate, //check
        policyTypeId: policyType,
        nameInsured: insuredName,
        targetPremium: premium,
        calcPremium: null,
        policyStartDate: policyStartDate, //check
        policyEndDate: policyEndDate, //check
        policyStatus: Number(this.brokerQuoteService.getStatusId()), //check
        mtaStatus: null,
        policyStep: null,
        policyUserLock: null,
        createdUserId: userId,
        createdDate: currentDate,
        updatedUserId: userId,
        updatedDate: currentDate,  
        addresses: addresses,      
      },
      questions: questions
    }
    const path=`/api/Clearance/SavePolicyClearance`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, requestBody);
  }

  getPolicyTypes() {
    const path=`/api/Clearance/GetPolicyTypes`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<any[]>(`${this.Url}/Proxy?path=${encodedPath}`);
  }

  getQuestions() {
    const path=`/api/QuestionMasters/clearance`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<any[]>(`${this.Url}/Proxy?path=${encodedPath}`);
  }

 getOccupanciesList(){
  const path=`/api/Clearance/GetOccupancyList`
  const encodedPath = encodeURIComponent(path);
  return this.httpClient.get<any[]>(`${this.Url}/Proxy?path=${encodedPath}`);
 }

 getPropertyEnhancementCoverages(){
  const path=`/api/PolicyParameters/GetPropertyEnhancement`
  const encodedPath = encodeURIComponent(path);
  return this.httpClient.get<any[]>(`${this.Url}/Proxy?path=${encodedPath}`);
 }

  copeStepIndication(requestPayload: { factors: any[]; addresses: any[]}, premiumAmount: any){

    const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const indicationId = Number(sessionStorage.getItem("indicationId"));
    const userId = userDetails.userId; 
    const requestBody = {
      indicationId: indicationId,
      userid: userId,
      targetPremium: premiumAmount,
      addresses: requestPayload.addresses 
    };
    const path=`/api/Cope/SaveIndicationCopeData`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, requestBody);
    
  } 

  copeStepQuote(requestPayload: { factors: any[]; addresses: any[]}, premiumAmount: any){

    const quoteId = sessionStorage.getItem('quoteId');
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId; 
    const requestBody = {
      quoteid: quoteId,
      userid: userId,
      targetPremium: premiumAmount,
      addresses: requestPayload.addresses 
    };
    const path=`/api/Cope/CopeData`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, requestBody);
    
  } 

  policySaveCopeData(requestPayload: { factors: any[]; addresses: any[]}, premiumAmount: any) {
    const requestBody = {
      policyId: Number(this.authService.getUserDetailsFromStorage()?.policyId),
      userid: Number(this.authService.getUserDetailsFromStorage()?.userDetails?.userId),
      targetPremium: premiumAmount,
      addresses: requestPayload.addresses 
    };
    const path=`/api/Cope/SavePolicyCopeData`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, requestBody);
  }
  
  PolicyStepIndication(formData: any): Observable<any> {
    const path=`/api/PolicyParameters/SaveIndicationPolicyParameters`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, formData);
  }

  PolicyStepQuote(formData: any): Observable<any> {
    const path=`/api/PolicyParameters/SavePolicyParameters`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.post(url, formData);
  }

  policyMTASave(formData: any): Observable<any> {
    const path=`/api/PolicyParameters/SavePolicyParametersforPolicy`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, formData);
  }

  getAopDeductibles(): Observable<any> {
    const path=`/api/PolicyParameters/GetAOPDeductibles`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.get(url);
  }

  getWindDeductibles(): Observable<any> {
    const path=`/api/PolicyParameters/GetWindDeductibles`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.get(url);
  }

  getWaterDamageCoverages(): Observable<any> {
    const path=`/api/PolicyParameters/GetExtensionCoverage?coverage=water`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.get(url);    
  }

  getVandalismCoverages(): Observable<any> {
    const path=`/api/PolicyParameters/GetExtensionCoverage?coverage=vandalism`
    const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.get(url);    
    }

  getOAndLCoverages(): Observable<any> {
    const path=`/api/PolicyParameters/GetExtensionCoverage?coverage=oandl`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;
    return this.httpClient.get(url);    
  }

  getCoverageFactors(): Observable<any> {
    const path=`/api/PolicyParameters/GetOtherStructureFactors`
    const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.get(url);    
    }

    getCauseOfLossOptions(): Observable<any> {
      const path=`/api/PolicyParameters/GetCauseOfLoss`
      const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.get(url); 
    }
   
  // getStates(cityName: string): Observable<string[]> {
  //   return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}/api/Clearance/States?CityName=${cityName}`);
  // }

   getStates(): Observable<string[]> {
    const path=`/api/Clearance/States`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}`);
  }  
  
  // getCounties(cityName: string): Observable<string[]> {
  //   return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}/api/Clearance/Counties?CityName=${cityName}`);
  // }

  getCounties(stateId: number): Observable<string[]> {
    const path=`/api/Clearance/Counties?stateId=${stateId}`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}`);
  }
  
  // getCities(): Observable<string[]> {
  //   return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}/api/Clearance/Cities`);
  // }

  getCities(countyId:number):Observable<string[]> {
    const path=`/api/Clearance/Cities?countyId=${countyId}`
    const encodedPath = encodeURIComponent(path);
     return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}`);
  }

  getZipCode(zipcode:string, countyId?: number):Observable<string[]> {
    const path=`/api/Clearance/GetStateforZipcode?zipcode=${zipcode}${countyId ? `&countyId=${countyId}` : ''}`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get<string[]>(`${this.Url}/Proxy?path=${encodedPath}`);
 }
  
  newMessageForTempQuote(userId: number, tempQuoteId: number, message: string){
    const path=`/api/TempQuoteMessages?tempquoteid=${tempQuoteId}&userid=${userId}&message=${message}`
    const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, null, {responseType: 'text'}).pipe(
        map(response => {
          try {
            return {success: true, message: response}
          } catch (e) {
            return { success: false, message: response };
          }
        }),
        catchError((error: HttpErrorResponse) => {
          // You can return a structured error response as well
          return of({ success: false, message: error.error });
        })
      );
    }

    newMessageForQuote(userId: number, quoteId: number, message: string){
      const path=`/api/QuoteMessages?quoteid=${quoteId}&userid=${userId}&message=${message}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, null, {responseType: 'text'}).pipe(
        map(response => {
          try {
            return {success: true, message: response};
          } catch (e) {
            return { success: false, message: response };
          }
        }),
        catchError((error: HttpErrorResponse) => {
          // You can return a structured error response as well
          return of({ success: false, message: error.error });
        })
      );
    }

    getAllUserMessageForTempQuote(tempQuoteId: number){
      const path=`/api/TempQuoteMessages/${tempQuoteId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    getAllUserMessageForQuote(quoteId: number){
      const path=`/api/QuoteMessages/${quoteId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    uploadDocument(file: FormData){
      const path=`/api/DocumentMaster/UploadDocuments`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy/Upload?path=${encodedPath}`, file)

    }

    getDtcRule(id:number, type:string){
      const path=`/api/PolicyParameters/CheckDTCRule?id=${id}&type=${type}`
      const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.get(url,{responseType: 'text'}).pipe(
        map(response => {
                 try {
                   return {success: true, message: response}
                 } catch (e) {
                   return { success: false, message: response };
                 }
               }),
               catchError((error: HttpErrorResponse) => {
                 // You can return a structured error response as well
                 return of({ success: false, message: error.error });
               })
     );
   
    }

    getDocuments(documentIds: number[]){
      const documentIdsParam = documentIds.map(id => `documentIds=${id}`).join('&');
      const path=`/api/DocumentMaster/GetDocuments?${documentIdsParam}`
      const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.get(url);
    }

    getDocumentsByEntities(payload: any) {
      const path=`/api/DocumentMaster/GetDocumentsByEntities`
      const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.post(url, payload);
    }
    

    getViewDocumentUrl(documentId: number): string {
      const path=`/api/DocumentMaster/ViewDocument/${documentId}`
      const encodedPath = encodeURIComponent(path);
      return `${this.Url}/Proxy?path=${encodedPath}`;
    }

    getViewDocumentUrls(documentId: number): SafeUrl {
      const path=`/api/DocumentMaster/ViewDocument/${documentId}`
      const encodedPath = encodeURIComponent(path);
      const url = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(url); // Sanitize URL
    }

    getDocumentContent(documentId: number): Observable<any> { // Returns the file content
      const path=`/api/DocumentMaster/ViewDocument/${documentId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`, { responseType: 'blob' }); // Important: responseType: 'blob'
    }
    

    downloadDocument(documentId: number): Observable<Blob> {
      const path=`/api/DocumentMaster/DownloadDocument/${documentId}`
      const encodedPath = encodeURIComponent(path);
      const downloadUrl = `${this.Url}/Proxy?path=${encodedPath}`;
      return this.httpClient.get(downloadUrl, { responseType: 'blob' });
    }

    // getDocumentContent(documentId: number): Observable<any> { // Returns the file content
    //   return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}/api/DocumentMaster/ViewDocument/${documentId}`, { responseType: 'blob' }); // Important: responseType: 'blob'
    // }

    deleteDocument(documentId: number): Observable<any> {
      const path=`/api/DocumentMaster/SoftDeleteDocument/${documentId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`,{});
    }

    uploadDocumentForQuote(file: FormData, quoteId: number, quotenumber: string, UserId: number){
      const path=`/api/QuoteDocuments?quoteid=${quoteId}&quotenumber=${quotenumber}&UserId=${UserId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, file)
    }

    uploadDocumentForTempQuote(file: FormData, quoteId: number, quotenumber: string, UserId: number){
      const path=`/api/TempQuoteDocuments?quoteid=${quoteId}&quotenumber=${quotenumber}&UserId=${UserId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, file)
    }

    getAllQuoteVersions(){
      const branchId = sessionStorage.getItem('branchId');
      const indicationId = sessionStorage.getItem("indicationId");
      const path=`/api/Quote/GetAllQuoteVersions?indicationId=${indicationId}&branchId=${branchId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<quoteComparisonResponce>(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    setVersionNo(versionNo: number) {
      sessionStorage.setItem('versionNo', String(versionNo));
    }
 
    getVersionNo(){
      return sessionStorage.getItem('versionNo');
    }

    setTIV(tiv: number) {
      sessionStorage.setItem('tiv', String(tiv));
    }
    
    getTIV(){
      return sessionStorage.getItem('tiv');
    }

    amendIndication(){
      const indicationId = sessionStorage.getItem("indicationId");
      const branchId = sessionStorage.getItem('branchId');
      const path=`/api/Indication/PostAmendIndication?indicationId=${indicationId}&branchId=${branchId}`
      const encodedPath = encodeURIComponent(path);

      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`,{})
    }

     UpdateIndicationDraftIndication(indicationDraft: number){
      const indicationId = sessionStorage.getItem("indicationId");
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      const userId = userDetails.userId;      
      const path=`/api/Indication/UpdateIndicationDraft?indicationId=${indicationId}&userId=${userId}&indicationDraft=${indicationDraft}`
      const encodedPath = encodeURIComponent(path);

      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`,{})
    }

    UpdateIndicationDraftQuote(indicationDraft: number){
      const quoteId = sessionStorage.getItem('quoteId')      
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      const userId = userDetails.userId;      
      const path=`/api/Quote/UpdateQuoteDraft?quoteId=${quoteId}&userId=${userId}&quoteDraft=${indicationDraft}`
      const encodedPath = encodeURIComponent(path);

      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`,{})
    }

    getindicationDraftStatusIndication(){
      const indicationId = sessionStorage.getItem("indicationId");      
      const path=`/api/Indication/${indicationId}/draft`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<any>(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    getindicationDraftStatusQuote(){
      const quoteId = sessionStorage.getItem('quoteId')      
      const path=`/api/Quote/${quoteId}/draft`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<any>(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    getGetPRApiResponseIndication(){
      const indicationId = sessionStorage.getItem("indicationId");      
      const path=`/api/Cope/GetPRApiResponse?indicationId=${indicationId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<any>(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    getGetPRApiResponseQuote(){
      const quoteId = sessionStorage.getItem('quoteId')      
      const path=`/api/Cope/GetPRApiResponse?quoteId=${quoteId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get<any>(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    RefreshIcon(body: any){
      const path=`/api/ConnectHub/RefreshPreferredReport`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post<any>(`${this.Url}/Proxy?path=${encodedPath}`, body);
    }

    getIndicationClearanceData(indicationId:number){
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

      const userId = userDetails.userId;
      const path=`/api/Clearance/GetIndicationClearanceData?indicationId=${indicationId}&UserId=${userId}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<clearanceIndicationData>(`${this.Url}/Proxy?path=${encodedPath}`)
      }    
  
    getQuoteClearanceData(quoteId:number){
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;
        const path=`/api/Clearance/GetQuoteClearanceData?quoteId=${quoteId}&UserId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<clearanceQuoteData>(`${this.Url}/Proxy?path=${encodedPath}`)
    }   
  
      getIndicationCopeData(indicationId: number){
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;
        const path=`/api/Cope/GetIndicationCopeData?indicationId=${indicationId}&UserId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`)
      }
  
      getQuoteCopeData(quoteId:number){
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;
        const path=`/api/Cope/GetCopeData?quoteId=${quoteId}&UserId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`)
      }
  
      getPolicyParametersIndication(indicationId:number){
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;
        const path=`/api/PolicyParameters/GetIndicationPolicyParameters?userId=${userId}&indicationId=${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<PolicyParametersData>(`${this.Url}/Proxy?path=${encodedPath}`)
  
      }   
  
      getPolicyParametersQuote(quoteId:number){
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;
        const path=`/api/PolicyParameters/GetPolicyParameters?quoteId=${quoteId}&UserId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<PolicyParametersData>(`${this.Url}/Proxy?path=${encodedPath}`)
  
      }

      getPolicyClearanceStepData(policyId: number, UserId: number) {
        const path=`/api/Clearance/GetPolicyClearanceData?policyId=${policyId}&UserId=${UserId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
      }
      
      getPolicyCopeStepData(policyId: number, UserId: number) {
        const path=`/api/Cope/GetPolicyCopeData?policyId=${policyId}&UserId=${UserId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
      }

      getPolicyForPolicyParamaterStepData(policyId: number, UserId: number) {
        const path=`/api/PolicyParameters/GetPolicyParametersforPolicy?userId=${UserId}&policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
      }

      policyParamerterUpdateOanL(payload: any[]){
        const path=`/api/PolicyParameters/UpdateOandLFlags`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, payload);
      }

      policyParamerterUpdateQuoteOanL(payload: any[]){
        const path=`/api/PolicyParameters/UpdateQuoteOandLFlags`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, payload);
      }




      fetchPolicyParameterIndicationOandL(indicationId: number){ 
        const path=`/api/PolicyParameters/GetOandLDetails?indicationId=${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
      }

      fetchPolicyParameterQuoteOandL(quoteId: number, versionId: number){ 
        const path=`/api/PolicyParameters/GetQuoteOandLDetails?quoteId=${quoteId}&versionNo=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
      }

      getPolicyOandLDetails(policyId: number) {
        const path=`/api/Policy/GetPolicyOandLDetails?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
      }

      updateToBuildingListByAddressId(addressData: any[]){
        const addressGroups: any = {};

        addressData.forEach(item => {
          if (!addressGroups[item.addressid]) {
              addressGroups[item.addressid] = 1;
          }
          item.buildingNum = addressGroups[item.addressid];
          addressGroups[item.addressid]++;
        });

        return addressData;
      }

      sortCountyRecords(records: any[]){
        if(records.length > 0){
          records.sort((a, b) => {
            const nameA = a.countyName.toLowerCase();
            const nameB = b.countyName.toLowerCase();
            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
          });
        }
        return records;
      };

      sortCityRecords(records: any[]){
        if(records.length > 0){
          records.sort((a, b) => {
            const nameA = a.cityName.toLowerCase();
            const nameB = b.cityName.toLowerCase();
            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
          });
        }
        return records;
      }

    fetchCrimeRatingList() {
      const path=`/api/Cope/GetCopeInfoList?genCode=crimerating`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }
    
    fetchConstructionTypeList() {
      const path=`/api/Cope/GetCopeInfoList?genCode=CONSTTYPE`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);

    }

    fetchRoofTypeList() {
      const path=`/api/Cope/GetCopeInfoList?genCode=ROOFTYPE`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);

    }
    
    fetchProtectionClassList() {
      const path=`/api/Cope/GetCopeInfoList?genCode=PcClass`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    applyDelayedFilter(key: string, delay: number, filterCallback: () => void) {
      if (!this.filterTimeouts) {
        this.filterTimeouts = {}; // Ensure it's initialized
      }

      // Clear any existing timeout for the specific key
      if (this.filterTimeouts[key]) {
        clearTimeout(this.filterTimeouts[key]);
      }

      // Set a new timeout for the specific key
      this.filterTimeouts[key] = setTimeout(() => {
        filterCallback();
        this.filterTimeouts[key] = null; // Reset the timeout reference
      }, delay);
    }
    




    fetchBuildingDetails(addressRequestBody: any, subRequestId: number): Observable<any> {
      const {city, state,zipcode ,street,streetNum,unitNum} = addressRequestBody;
     const quoteNo = sessionStorage.getItem("indicationNo");
      const body = {
        Addresses: [
          {
            externalRequestId: quoteNo, 
            subRequestId: PreferredReports.subRequestId,
            streetNumber: String(streetNum),      
            unit: String(unitNum),
            city:String(city),
            state:String(state),
            zipcode:String(zipcode),
            streetName:String(street)
          },
        ],
      };
    
      const headers = new HttpHeaders({
        'API-KEY': this.apiKey,
      });
    
    
      return this.httpClient.post(`${this.apiUrl}`, body, { headers });
    }

    getIsEditedAddress(id: number, type: string): Observable<any> {
      const path = `/api/Clearance/GetIsEditedAddress?id=${id}&Type=${type}`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    updateIsEditAddress(payload: any): Observable<any> {
      const path = `/api/Clearance/UpdateIsEditAddress`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, payload);
    }

    CheckEQBDReferral(id: number, type: string, userId: number, VersionNo: number): Observable<any> {
      const path = `/api/Clearance/CheckEQBDReferral?id=${id}&Type=${type}&userId=${userId}&VersionNo=${VersionNo}`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, {});
    }

    UpdateClearanceAddressEdit(id: number, userId: number, clearanceAddressEdited: number, type: string): Observable<any> {
      const path = `/api/Clearance/UpdateClearanceAddressEdit?id=${id}&userId=${userId}&clearanceAddressEdited=${clearanceAddressEdited}&type=${type}`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, {});
    }

    GetClearanceAddressEdit(id: number, type: string): Observable<any> {
      const path = `/api/Clearance/GetClearanceAddressEdit?id=${id}&type=${type}`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    GetClearanceCheckFlag(id: number, type: string): Observable<any> {
      const path = `/api/Clearance/GetClearanceCheckFlag?id=${id}&type=${type}`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.get(`${this.Url}/Proxy?path=${encodedPath}`);
    }

    ClearanceCheckApproval(payload: any): Observable<any> {
      const path = `/api/UWAdminReview/ClearanceCheckApproval`;
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.Url}/Proxy?path=${encodedPath}`, payload);
    }
}
